import { useVendorAuthStore } from '@/store/vendorAuthStore';
import { useShopStore } from '@/store/shopStore';
import { VENDOR_ROLE } from '@/constants/vendorRole';

/** vendorInfo.roleName이 도매인지 확인 */
export function isSupplierUser(roleName?: string | null): boolean {
    if (!roleName) return false;
    return roleName === '도매' || roleName === VENDOR_ROLE.SUPPLIER;
}

/** 도매 쇼핑몰 + 도매 사용자 로그인 = 허용 불가 조합인지 확인 */
export function isIncompatibleVendorLogin(): boolean {
    const shop = useShopStore.getState().shop;
    const vendorInfo = useVendorAuthStore.getState().vendorInfo;
    if (!shop || !vendorInfo) return false;
    return shop.role === VENDOR_ROLE.SUPPLIER && isSupplierUser(vendorInfo.roleName);
}

/** 비호환 vendor 인증 정보 제거 */
export function clearIncompatibleVendorAuth(): void {
    useVendorAuthStore.getState().reset();
}
